/**
 * AI CODE
 * 뷰티풀한 색상 생성
 * @param baseH 색조
 * @param baseS 채도
 * @param startL 시작 밝기
 * @param endL 끝 밝기
 * @param count 색상 개수
 * @returns
 */
export const generateColorList = (baseH = 20, baseS = 95, startL = 65, endL = 45, count = 31) => {
    const colors = [];
    for (let i = 0; i < count; i += 1) {
        const ratio = i / (count - 1); // 0 → 1
        const l = Math.round(startL - (startL - endL) * ratio); // 밝기 점점 어둡게
        const s = baseS; // 채도 고정
        const h = baseH; // 색조 고정 (주황색)
        colors.push(`hsl(${h}, ${s}%, ${l}%)`);
    }
    return colors;
};
/**
 * AI CODE
 * 숫자를 엑셀 열 문자로 변환
 * @param n 숫자
 * @returns 엑셀 열 문자
 */
export const numberToColumn = (n) => {
    let result = '';
    while (n >= 0) {
        result = String.fromCharCode((n % 26) + 65) + result;
        // eslint-disable-next-line no-param-reassign
        n = Math.floor(n / 26) - 1;
    }
    return result;
};
/** 각도를 라디안으로 변환 */
const deg2rad = (degree) => degree * (Math.PI / 180);
/**
 * 거리 계산
 */
export const getCalcDistance = (lat1, lng1, lat2, lng2) => {
    const R = 6371; // 지구 반지름 (단위: km)
    const dLat = deg2rad(lat2 - lat1);
    const dLon = deg2rad(lng2 - lng1);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
        + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2))
            * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c; // 두 지점 간의 거리 (단위: km)
    if (Number.isNaN(distance) || distance > 999) {
        return '-';
    }
    // 0.01보다 작으면 반올림 (10m 이하는 10m로 표기)
    if (distance < 0.01) {
        return '0.00km';
    }
    return `${distance.toFixed(2)}km`;
};
